import axios from 'axios'
import {
	ElMessage
} from 'element-plus'
import {
	hideLoading,
	showLoading
} from '/request/loading'
import VueCookies from 'vue-cookies'

const service = axios.create({
	// process.env.NODE_ENV === 'development' 来判断是否开发环境
	// easy-mock服务挂了，暂时不使用了
	// baseURL: 'http://localhost:3001',
	// baseURL: '/api',
	timeout: 500000000
})

service.interceptors.request.use(
	config => {
		// showLoading()
		config.headers['Token'] = `${VueCookies.get('token')}`
		return config
	},
	error => {
		console.log(error)
		// eslint-disable-next-line prefer-promise-reject-errors
		return Promise.reject()
	}
)

service.interceptors.response.use(
	response => {
		// hideLoading()
		if (response.data.code === 0) {
			return response.data
		} else if (response.data.code === 401001) {
			if (VueCookies.get('token') && VueCookies.get('token') !== '') {
				VueCookies.remove('token')
				location.reload()
			}
			ElMessage.error(response.data.msg)
			return Promise.reject(new Error(response.data.msg));
		} else {
			ElMessage.error(response.data.msg)
			// eslint-disable-next-line prefer-promise-reject-errors
			return Promise.reject(new Error(response.data.msg));
		}
	},
	error => {
		console.log(error)
		// eslint-disable-next-line prefer-promise-reject-errors
		return Promise.reject()
	}
)

export default service